import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const perfP4UnderUtilizedOvw202602: FaireAdPerformancePeriodEntity = {
  token: "perf_p4_under_utilized_ovw_202602",
  type: "adPerformancePeriod",
  scope: "OVERVIEW",
  periodType: "RECEIPT",
  startDate: "2026-02-01",
  endDate: "2026-02-28",
  impressions: 12091,
  clicks: 166,
  adsSpendDollars: 600,
  budgetDollars: 15000,
  salesDollars: 9397,
  bestEstimateRoas: 15.66,
  bestEstimateType: "ACTUALIZED",
  budgetUtilization: 0.04,
  newCustomersAcquired: 5,
  reorderConversions: 7,
  dataAvailableAtDate: "2026-03-04",
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
